<template>
  <div class="content">
    <div class="row mt-0">
      <div class="col-12">
        <card card-body-classes="table-full-width">
          <h4 slot="header" class="card-title text-left">
            Excluir Batidas Duplicadas
          </h4>
          <form @submit.prevent="handleDelete" class="text-left">
            <div class="col-sm-4">
              <!-- Campo de seleção de mês -->
              <div class="form-group">
                <label for="mesReferencia">Mês Referente</label>
                <select v-model="mesSelecionado" class="form-control">
                  <option
                    v-for="mes in meses"
                    :key="mes.value"
                    :value="mes.value"
                  >
                    {{ mes.label }}
                  </option>
                </select>
              </div>

              <!-- Botão de verificação -->
              <base-button
                type="primary"
                :disabled="!mesSelecionado || isLoading"
                @click="verificarDuplicatas"
                class="btn btn-primary mt-2"
              >
                Verificar Duplicatas
              </base-button>

              <!-- Botão de exclusão -->
              <base-button
                type="danger"
                :disabled="
                  !mesSelecionado ||
                    isLoading ||
                    duplicatasEncontradas === null ||
                    duplicatasEncontradas === 0
                "
                @click="handleDelete"
                class="btn btn-danger mt-2"
              >
                Excluir Duplicatas ({{ duplicatasEncontradas || 0 }})
              </base-button>
            </div>
          </form>
        </card>
      </div>
    </div>

    <div class="vld-parent">
      <loading
        :active.sync="isLoading"
        :can-cancel="false"
        loader="spinner"
        color="#ff0000"
        :is-full-page="true"
      ></loading>
    </div>
  </div>
</template>

<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { Card } from "@/components/index";
import swal from "sweetalert2";

export default {
  components: {
    Card,
    Loading
  },
  data() {
    return {
      isLoading: false,
      mesSelecionado: "",
      duplicatasEncontradas: null,
      meses: this.gerarMeses()
    };
  },
  methods: {
    gerarMeses() {
      const meses = [];
      const hoje = new Date();
      for (let i = 0; i < 12; i++) {
        const data = new Date(hoje.getFullYear(), hoje.getMonth() - i, 1);
        const mesFormatado = `${String(data.getMonth() + 1).padStart(
          2,
          "0"
        )}/${data.getFullYear()}`;
        const dataCompleta = `${data.getFullYear()}-${String(
          data.getMonth() + 1
        ).padStart(2, "0")}-01`;
        meses.push({ label: mesFormatado, value: dataCompleta });
      }
      return meses;
    },
    async verificarDuplicatas() {
      if (!this.mesSelecionado) {
        swal("Erro", "Selecione um mês para verificar as duplicatas.", "error");
        return;
      }

      this.isLoading = true;

      try {
        const response = await this.axios.post(
          "/api/movimentacoes/verificarDuplicidade",
          {
            mesReferencia: this.mesSelecionado,
            setDB: this.$cookies.get("db")
          }
        );

        this.isLoading = false;

        if (response.data && response.data.duplicatasEncontradas > 0) {
          this.duplicatasEncontradas = response.data.duplicatasEncontradas;
          swal(
            "Duplicatas Encontradas",
            `${this.duplicatasEncontradas} registros duplicados foram encontrados.`,
            "info"
          );
        } else {
          this.duplicatasEncontradas = 0;
          swal(
            "Nenhuma Duplicata",
            "Não foram encontradas duplicatas para este mês.",
            "info"
          );
        }
      } catch (error) {
        console.error("Erro ao verificar duplicatas:", error);
        this.isLoading = false;
        swal("Erro", "Falha ao verificar duplicatas.", "error");
      }
    },
    async handleDelete() {
      if (
        !this.mesSelecionado ||
        this.duplicatasEncontradas === null ||
        this.duplicatasEncontradas === 0
      ) {
        swal(
          "Erro",
          "Primeiro verifique as duplicatas antes de excluir.",
          "error"
        );
        return;
      }

      const confirmacao = await swal.fire({
        title: "Tem certeza?",
        text: `Você deseja excluir ${this.duplicatasEncontradas} duplicatas?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Sim, excluir!",
        cancelButtonText: "Cancelar"
      });

      if (!confirmacao.value) {
        return;
      }

      this.isLoading = true;

      try {
        const response = await this.axios.post(
          "/api/movimentacoes/excluirDuplicidade",
          {
            mesReferencia: this.mesSelecionado,
            setDB: this.$cookies.get("db")
          }
        );

        this.isLoading = false;

        if (response.data && response.data.duplicatasExcluidas > 0) {
          swal(
            "Sucesso",
            `${response.data.duplicatasExcluidas} duplicatas foram excluídas.`,
            "success"
          );
          this.duplicatasEncontradas = null; // Reset após a exclusão
        } else {
          swal(
            "Aviso",
            "Nenhuma duplicata foi encontrada para exclusão.",
            "info"
          );
        }

        this.mesSelecionado = "";
      } catch (error) {
        console.error("Erro ao excluir duplicatas:", error);
        this.isLoading = false;
        swal("Erro", "Falha ao excluir as duplicatas.", "error");
      }
    }
  }
};
</script>

<style>
.mt-0 {
  margin-top: 0;
}
.alert-danger {
  font-size: 0.875rem;
  background-color: #f8d7da;
  color: #721c24;
  border-color: #f5c6cb;
}
</style>
